// бургер;
$(document).ready(function () {
  const html = document.querySelector("html"),
    burger = document.querySelector(".burger"),
    menu = document.querySelector(".menu"),
    closeMenuBtn = document.querySelector("[data-js='close-menu']");

  function isVisibleMenuWowEls() {
    WOW.prototype.isVisible = function (e) {
      if (this.isPositionFixed(e)) return true;
    };
  }

  function r() {
    WOW.prototype.isPositionFixed = function (e) {
      for (
        var t;
        e.parentNode && "body" !== e.parentNode.localName && "fixed" !== t;

      )
        (t = getComputedStyle(e).position), (e = e.parentNode);
      return "fixed" != getComputedStyle(e).position;
    };
  }

  function closeMenu() {
    menu.style.height = "0";
    html.classList.remove("blocked");
  }

  burger.addEventListener("click", function () {
    menu.style.height = "100vh";
    html.classList.add("blocked");

    new WOW({
      boxClass: "m-wow",
      animateClass: "animated",
      offset: 0,
      mobile: !0,
      live: !1,
    }).init();

    WOW.prototype.isPositionFixed = function (e) {
      for (
        var t;
        e.parentNode && "body" !== e.parentNode.localName && "fixed" !== t;

      )
        (t = getComputedStyle(e).position), (e = e.parentNode);
      return "fixed" === getComputedStyle(e).position;
    };
    isVisibleMenuWowEls();
  });

  closeMenuBtn.addEventListener("click", function () {
    closeMenu();
    r();
    isVisibleMenuWowEls();
  });

  const mobMenuLinks = document.querySelectorAll(".m-nav__link");
  for (let link of mobMenuLinks)
    link.addEventListener("click", function (e) {
      closeMenu();
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ) && (r(), isVisibleMenuWowEls());
    });
});
